import React, { useState } from 'react';
import { signUp } from '../../../core/firebase/auth_service';

export default function Step4Password({ data, onBack, onLoginRedirect, onSuccess }) {
  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [show,      setShow]      = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState('');

  const strong = password.length >= 8;
  const match  = password === confirm && confirm.length > 0;

  const handleCreate = async () => {
    if (!strong) { setError('Minimum 8 caractères.'); return; }
    if (!match)  { setError('Les mots de passe ne correspondent pas.'); return; }
    setLoading(true);
    setError('');
    try {
      await signUp({ ...data, password });
      onSuccess();
    } catch (e) {
      if (e.code === 'auth/email-already-in-use') setError('Cet email est déjà utilisé.');
      else setError('Erreur : ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  const strength = password.length === 0 ? 0
    : password.length < 6 ? 1
    : password.length < 8 ? 2
    : /[A-Z]/.test(password) && /[0-9]/.test(password) ? 4 : 3;

  const strengthColor = ['#ddd','#e74c3c','#e67e22','#f1c40f','#27ae60'][strength];
  const strengthLabel = ['','Faible','Moyen','Bien','Fort'][strength];

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <button style={styles.back} onClick={onBack}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={styles.stepLabel}>Create Account (4/4)</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Mot de passe</h2>
        <p style={styles.sub}>Minimum 8 caractères</p>

        <div style={styles.inputWrapper}>
          <input
            style={styles.input}
            type={show ? 'text' : 'password'}
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            autoFocus
          />
          <button style={styles.eye} onClick={() => setShow(!show)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {show
                ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
              }
            </svg>
          </button>
        </div>

        {password.length > 0 && (
          <div style={styles.strengthRow}>
            {[1,2,3,4].map(i => (
              <div key={i} style={{ ...styles.strengthBar, background: i <= strength ? strengthColor : '#dde0f0' }} />
            ))}
            <span style={{ color: strengthColor, fontSize: 12, marginLeft: 6 }}>{strengthLabel}</span>
          </div>
        )}

        <div style={{ ...styles.inputWrapper, marginTop: 14 }}>
          <input
            style={styles.input}
            type={show ? 'text' : 'password'}
            placeholder="Confirmer le mot de passe"
            value={confirm}
            onChange={(e) => { setConfirm(e.target.value); setError(''); }}
          />
          {confirm.length > 0 && (
            <span style={{ fontSize: 18, color: match ? '#27ae60' : '#e74c3c' }}>
              {match ? '✓' : '✗'}
            </span>
          )}
        </div>

        {error && <p style={styles.error}>{error}</p>}
      </div>

      <div style={styles.bottom}>
        <button
          style={{ ...styles.btnNext, opacity: !strong || !match || loading ? 0.5 : 1 }}
          onClick={handleCreate}
          disabled={!strong || !match || loading}
        >
          {loading ? 'Création du compte...' : 'Créer mon compte'}
        </button>
        <button style={styles.loginLink} onClick={onLoginRedirect}>
          I already have an account
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7ff', display: 'flex', flexDirection: 'column', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px' },
  back: { background: 'none', border: 'none', cursor: 'pointer', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepLabel: { color: '#333', fontSize: 15, fontWeight: 600 },
  content: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 24px 20px' },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 },
  sub: { fontSize: 14, color: '#888', marginBottom: 40, textAlign: 'center' },
  inputWrapper: { display: 'flex', alignItems: 'center', width: '100%', maxWidth: 380, height: 54, background: '#fff', border: '1.5px solid #dde0f0', borderRadius: 14, padding: '0 16px', gap: 8 },
  input: { flex: 1, border: 'none', outline: 'none', fontSize: 16, color: '#222', background: 'transparent' },
  eye: { background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  strengthRow: { display: 'flex', alignItems: 'center', gap: 4, marginTop: 8, width: '100%', maxWidth: 380 },
  strengthBar: { height: 4, flex: 1, borderRadius: 4, transition: 'background 0.3s' },
  error: { color: '#e74c3c', fontSize: 13, marginTop: 10 },
  bottom: { padding: '0 24px 40px', display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' },
  btnNext: { background: '#3d5ef5', color: '#fff', border: 'none', borderRadius: 14, height: 54, fontSize: 16, fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: 480 },
  loginLink: { background: 'none', border: 'none', color: '#3d5ef5', fontSize: 14, fontWeight: 500, cursor: 'pointer' },
};
